export default function ClientTeam() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Team Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
